import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon } from 'rsuite';
import {
  showCameraRecorder,
  getIsUploadingVideo,
  getCampaignBanner,
  getUseCampaignBanner,
  getCampaignBrandFontColor,
  getCampaignLanguage,
} from '../../redux/modules/campaignLandingPage';
import { isRecordingSupported } from '../../helpers/supportedFeatureHelper';
import { StyledBrandingButton, StyledOutlineBrandingButton } from './styles';
import { getTranslation } from '../../translations/dictionary';

const VideoRecorderEnableButton = ({
  _showCameraRecorder,
  qid,
  isUploadingVideo,
  backgroundColor = '',
  color = '',
  useBanner = false,
  language,
  shouldHide,
}) => {
  if (!isRecordingSupported()) {
    return null;
  }
  const useCustomeStyle = useBanner && backgroundColor && color;
  const isWhitePrimaryColor = backgroundColor === 'rgb(255 255 255 / 1)';

  const recordLabel = getTranslation('record_video_label', language) || 'Record a Video';

  const sx = { gap: '5px' };
  if (shouldHide) {
    sx.display = 'none';
  }

  return isWhitePrimaryColor ? (
    <StyledOutlineBrandingButton
      component="label"
      variant="outlined"
      disabled={isUploadingVideo}
      onClick={() => _showCameraRecorder(qid)}
      backgroundColor={backgroundColor}
      custom={useCustomeStyle}
      fontColor={color}
      sx={sx}
    >
      <Icon icon="circle" />
      {recordLabel}
    </StyledOutlineBrandingButton>
  ) : (
    <StyledBrandingButton
      variant="contained"
      disabled={isUploadingVideo}
      onClick={() => _showCameraRecorder(qid)}
      backgroundColor={backgroundColor}
      fontColor={color}
      custom={useCustomeStyle}
      sx={sx}
    >
      <Icon icon="circle" />
      {recordLabel}
    </StyledBrandingButton>
  );
};

VideoRecorderEnableButton.propTypes = {
  _showCameraRecorder: PropTypes.func,
  qid: PropTypes.string,
  isVideoUploading: PropTypes.bool,
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  language: PropTypes.string,
  useBanner: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => ({
  isUploadingVideo: getIsUploadingVideo(state, ownProps.qid),
  backgroundColor: getCampaignBanner(state),
  useBanner: getUseCampaignBanner(state),
  color: getCampaignBrandFontColor(state),
  language: getCampaignLanguage(state),
});

const mapDispatchToProps = {
  _showCameraRecorder: showCameraRecorder
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoRecorderEnableButton);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/VideoRecorderEnableButton.jsx